import React from "react";
import Chart from "react-apexcharts";
import { COLORES_VENDEDOR } from "./constants";
import { formatCurrency, truncarNombre } from "./utils";

export default function GraficoTopVendedores(props) {
    const vendedores = props.vendedores || [];
    const valores = props.valores || [];
    const moneda = props.moneda || "PEN";
    const simbolo = moneda === "USD" ? "US$" : "S/";

    const options = {
        chart: {
            type: "bar",
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: "55%",
                borderRadius: 4,
                // Un color distinto por barra para que cada vendedor se
                // identifique en la leyenda igual que en el grafico de
                // participacion (dona).
                distributed: true,
            },
        },
        colors: COLORES_VENDEDOR,
        // El monto no se escribe encima de la barra (se corta o queda
        // centrado segun el ancho disponible); en su lugar se muestra en una
        // leyenda fija, siempre visible sin pasar el mouse.
        dataLabels: { enabled: false },
        xaxis: {
            categories: vendedores,
            title: { text: `Ventas (${simbolo})` },
            labels: {
                // Con montos chicos (< 1000) dividir entre 1000 siempre da "0K";
                // en ese caso se muestra el numero tal cual.
                formatter: (val) => (val >= 1000 ? `${Math.round(val / 1000)}K` : `${Math.round(val)}`),
            },
        },
        legend: {
            show: true,
            showForSingleSeries: true,
            position: "right",
            verticalAlign: "middle",
            fontSize: "12px",
            itemMargin: { vertical: 4 },
            formatter: (nombre, opts) => ` ${formatCurrency(valores[opts.seriesIndex], moneda)}`,
        },
        tooltip: {
            x: {
                // El titulo del tooltip usa la categoria (nombre del
                // vendedor) truncada, igual que en los otros graficos.
                formatter: (val) => truncarNombre(val),
            },
            y: {
                formatter: (val) => formatCurrency(val, moneda),
            },
        },
        grid: {
            padding: { left: 10, right: 10 },
        },
        // En pantallas angostas la leyenda a la derecha aprieta las barras;
        // ahi se pasa a leyenda inferior (mismo criterio que la dona).
        responsive: [
            {
                breakpoint: 992,
                options: {
                    legend: {
                        position: "bottom",
                        verticalAlign: "middle",
                        itemMargin: { horizontal: 8, vertical: 4 },
                    },
                },
            },
        ],
    };

    return (
        <Chart
            options={options}
            series={[{ name: "Ventas", data: valores }]}
            type="bar"
            height={320}
        />
    );
}
